export default __webpack_public_path__ + "static/media/calc.beff17d2.png";